import styled, { css } from 'styled-components';

import Select from 'Elements/Input/Select';
import ResetButton from 'Elements/Button/Reset';

export const Filters = styled.div`
    ${({ theme }) => css`
        margin-bottom: 1rem;
        display: flex;
        flex-direction: column;

        @media ${theme.breakpoints.medium.media} {
            flex-direction: row;
            flex-wrap: wrap;
        }
    `}
`;

export const SearchWrapper = styled.div`
    ${({ theme }) => css`
        margin-top: 1rem;

        @media ${theme.breakpoints.medium.media} {
            min-width: 25rem;
            margin-right: 1.25rem;
        }
    `}
`;

export const RoleSelect = styled(Select)`
    margin-top: 1rem;
    margin-right: 1.25rem;
    width: 10rem;
`;

export const DepartmentSelect = styled(Select)`
    ${({ theme }) => css`
        margin-top: 1rem;

        @media ${theme.breakpoints.medium.media} {
            margin-right: 1.25rem;
            width: 22.5rem;
        }
    `}
`;

export const StyledResetButton = styled(ResetButton)`
    ${({ theme }) => css`
        && {
            width: 10rem;
            margin-top: 1rem;
            height: 2.5rem;
            align-self: flex-end;

            @media ${theme.breakpoints.large.media} {
                height: auto;
            }
        }
    `}
`;
